import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { fromEnumAsString, toEnumFromString } from '../../../../serialization/enum-utils.js';
import { BusinessModuleRef } from '../../business-module-ref.js';
import { PaymentMethod } from '../../payment-method.js';
import { AuditLogEntry } from '../audit-log-entry.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';

/** Records a correction without producing additional sale or refund lines. */
export class AdminOrderPaymentMethodChangedEntry extends AuditLogEntry {
  static readonly TYPE_ID = 'f9cf0c373e7f4a77a844592b8f84e229';

  constructor(
    public readonly businessRef: BusinessModuleRef,
    public readonly orderId: string,
    public readonly changedBy: string | null,
    public readonly oldPaymentMethod: PaymentMethod,
    public readonly newPaymentMethod: PaymentMethod,
  ) {
    super();
  }

  get $typeId(): string { return AdminOrderPaymentMethodChangedEntry.TYPE_ID; }
  get type(): AuditLogEntryType { return AuditLogEntryType.AdminOrderPaymentMethodChanged; }

  generateQueryData(): SerializedData {
    return { businessRef: this.businessRef.encode(), orderId: this.orderId };
  }

  static fromMap(_context: SerializationContext, map: SerializedData): AdminOrderPaymentMethodChangedEntry {
    return new AdminOrderPaymentMethodChangedEntry(
        BusinessModuleRef.decode(MapUtils.getString(map, 'businessRef'))!,
        MapUtils.getString(map, 'orderId'),
        MapUtils.getStringOrNull(map, 'changedBy'),
        toEnumFromString(MapUtils.getString(map, 'oldPaymentMethod'), PaymentMethod),
        toEnumFromString(MapUtils.getString(map, 'newPaymentMethod'), PaymentMethod),
    );
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      businessRef: this.businessRef.encode(),
      orderId: this.orderId,
      changedBy: this.changedBy,
      oldPaymentMethod: fromEnumAsString(this.oldPaymentMethod),
      newPaymentMethod: fromEnumAsString(this.newPaymentMethod),
    };
  }

  clone(): this {
    return new AdminOrderPaymentMethodChangedEntry(
        this.businessRef.clone(), this.orderId, this.changedBy, this.oldPaymentMethod, this.newPaymentMethod,
    ) as this;
  }

  isSame(other: this): boolean {
    return this.businessRef.isSame(other.businessRef) && this.orderId === other.orderId &&
      this.changedBy === other.changedBy && this.oldPaymentMethod === other.oldPaymentMethod &&
      this.newPaymentMethod === other.newPaymentMethod;
  }
}

export class AdminOrderPaymentMethodChangedEntryBuilder extends DataModelBuilder<AdminOrderPaymentMethodChangedEntry> {
  build(context: SerializationContext, map: SerializedData): AdminOrderPaymentMethodChangedEntry {
    return AdminOrderPaymentMethodChangedEntry.fromMap(context, map);
  }
}
